<template>

    <div class="card">
        <div class="card-header border-bottom">
            <i class="fas fa-language me-2"></i>{{ TR.languages }}
        </div>
        <div class="card-body container1 p-4">

            <Tabs ref="tabviewLang" v-model:value="active">

                <TabList>
                    <Tab value="0">
                        <i class="fa fa-list me-2"></i>
                        <span>{{ TR.languages }}</span>
                    </Tab>
                    <Tab v-if="selected_lang.fullname !== undefined" value="1">
                        <i class="fa fa-edit me-2"></i>
                        <span>{{ selected_lang.fullname }}</span>
                    </Tab>
                </TabList>

                <TabPanels>
                    <TabPanel value="0">

                        <DADataTable
                            ref="doyouknow_table_ref"
                            v-if="tableData"
                            :tableData="tableData"
                            :tableOptions="tableOptions"
                        />

                    </TabPanel>

                    <TabPanel v-if="selected_lang.fullname !== undefined" value="1">

                        <div v-if="G.userHavePermission('add')" class="row mb-3">
                            <div class="col-12 col-sm-8 offset-sm-2">

                                <fieldset class="p-3 mb-3 text-primary border-bottom border-primary border-2">
                                    <legend class="fw-bold mb-3">{{ TR.add }}</legend>
                                    <div class="row my-3">
                                        <div class="col-12 col-sm-4 mb-3 mb-sm-0">
                                            <label>{{TR.key}}</label>
                                            <input type="text" class="form-control" v-model="new_lang['key']" />
                                        </div>
                                        <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                                            <label>{{TR.value}}</label>
                                            <input type="text" class="form-control" v-model="new_lang['value']" />
                                        </div>
                                        <div class="col-12 col-sm-2 mb-3 mb-sm-0 align-self-end">
                                            <button v-if="G.userHavePermission('add')" class="btn btn-primary" @click="addLanguageKeyValue(new_lang['key'], new_lang['value'])"><i class="fas fa-plus me-2"></i>{{ TR.add }}</button>
                                        </div>
                                    </div>
                                </fieldset>

                            </div>
                        </div>

                        <div class="row mb-4 py-3">
                            <div class="col-12 col-sm-6 offset-sm-3">
                                <!-- <input ref="searchField" type="text" class="form-control mb-3" :placeholder="TR.search" v-model="searchText" /> -->
                                <InputClear ref="searchField" class="mb-2" :placeholder="TR.search" v-model="searchText" />

                                <div v-if="searchText != '' && Object.keys(filtered).length > 0">
                                    {{ Object.keys(filtered).length }} {{ TR.find_result }}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row row-cols-1 row-cols-md-4 g-4 mt-2">
                            <div class="col" v-for="( item, index ) in filtered" :key="index">
                                <div v-if="item != ''" class="card border mb-2">
                                    <div class="card-header border-bottom fw-normal">Key: <b>{{ index }}</b></div>
                                    <div class="card-body p-4 d-flex align-items-start">
                                        <textarea type="text" class="form-control mx-2" rows="1" v-model="language[index]"></textarea>
                                        <button v-if="G.userHavePermission('update')" class="btn btn-primary" @click="updateLanguageKeyValue(index, item)"><i class="fas fa-save"></i></button>
                                        <button class="btn btn-danger"><i class="fas fa-trash"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- <input type="text" class="form-control mx-2" v-model="language[index]" /> -->
                        <div class="row text-center fw-bold pb-4">

                            <div class="col-12 col-sm-2 offset-sm-2">{{ TR.key }}</div>
                            <div class="col-12 col-sm-6">{{ TR.value }}</div>
                        </div>
                        <div class="row mb-2" v-for="( item, index ) in filtered" :key="index">
                            <template v-if="index != ''">
                                <div class="col-12 col-sm-2 offset-sm-2">{{ index }}</div>
                                <div class="col-12 col-sm-6 d-flex align-items-start">
                                    <button v-if="G.userHavePermission('update')" class="btn btn-primary" @click="updateLanguageKeyValue(index, item)"><i class="fas fa-save"></i></button>
                                    <textarea type="text" class="form-control mx-2" rows="1" v-model="language[index]"></textarea>
                                    <button v-if="G.userHavePermission('remove')" class="btn btn-danger" @click="removeByKey(index)"><i class="fas fa-trash"></i></button>
                                </div>
                            </template>
                        </div>

                    </TabPanel>
                </TabPanels>

            </Tabs>

        </div>
    </div>
</template>

<script>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from "@/store";
    import moment from "moment-timezone";

    import Tabs from 'primevue/tabs';
    import TabList from 'primevue/tablist';
    import Tab from 'primevue/tab';
    import TabPanels from 'primevue/tabpanels';
    import TabPanel from 'primevue/tabpanel';

    import InputClear from '@/components/field/InputClear';
    import DADataTable from "@/components/table/DADataTable";

    import { G, ajax } from '@/_common';
    import { country_code } from '@/data/countryCode';

    export default {
        name: 'LanguageMultiP',
        title: 'language',
        components:{
            Tabs,
            TabList,
            Tab,
            TabPanels,
            TabPanel,
            InputClear,
            DADataTable,
        },
        setup() {
            const store = useStore();

            const TR = ref({});
            const tabviewLang = ref();
            const tableData = ref([]);
            const tableOptions = ref();
            const active = ref('0');

            const searchField = ref(null);
            const selected_lang = ref({});
            const language = ref({});
            const filtered = ref({});
            const searchText = ref('');
            const new_lang = ref({
                "key": '',
                "balue": '',
            });

            const selected_lang_item = ref("");

            const countries = country_code.map(e => {
                                    return {
                                        value: e.country.code.toLowerCase(),
                                        label: e.country.nameEn,
                                        icon: e.flag,
                                        flag: e.flag,
                                        currencyCode: e.currency.code,
                                        currencySymbol: e.currency.symbol,
                                    };
                                });

            watchEffect(() => {
                TR.value = store.getTranslation();
                if( searchText.value != '' ){
                    // language.value.map((e, i) => e[i].indexOf(searchText.value));
                    // filtered.value = Object.fromEntries(Object.entries(language.value).filter(([k,v]) => {
                    //     console.log(k, v);
                    //     return v.toString().search(searchText.value);
                    // }));
                    filtered.value = {};
                    // filtered.value = Object.keys(language.value).reduce(function (filtered1, key) {
                    //     if( language.value[key].toString().search(searchText.value) >= 0 ) filtered1[key] = language.value[key];
                    //     return filtered1;
                    // }, {});

                    Object.keys(language.value).filter((key) => {
                        // if( language.value[key].toString().match(/`${searchText.value}`/i) ) filtered.value[key] = language.value[key];
                        if( language.value[key].toString().match(new RegExp(searchText.value, 'i')) || key.match(new RegExp(searchText.value, 'i')) ){
                            filtered.value[key] = language.value[key];
                        }
                    }, {});

                }
                else{
                    filtered.value = language.value;
                }


                tableOptions.value = {
                    // row_total: true,
                    // row_total_field: ['rank'],
                    // rows: 5,
                    // globalFilterFields: ((sitem) => { console.log(sitem);
                    //  return ['shortname', 'fullname'];}), //['shortname', 'fullname'],

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    // modal: false,
                                    page: "components/table/DynamicTable2",
                                    modal_width: 30,
                                    dynamic_height: true,
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns: [
                                        // {
                                        //     name: "preview_image",
                                        //     title: TR.value.preview,
                                        //     // value: (e) => e.image,
                                        //     value: "image",
                                        //     field_type: "label",
                                        // },
                                        // {
                                        //     name: "image",
                                        //     title: TR.value.image,
                                        //     // value: (e) => e.image,
                                        //     field_type: "image",
                                        //     fileSelectMode: 'basic',
                                        //     // fileSelectMode: 'advanced',
                                        //     fileMaxSize: G.uploadedFileSize,
                                        //     fileLimit: 1,
                                        //     fileMultiple: false,
                                        // },
                                        // {
                                        //     name: "shortname",
                                        //     title: TR.value.shortname,
                                        //     // value: (e) => e.translate[0].name,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "fullname",
                                        //     title: TR.value.name,
                                        //     field_type: 'text',
                                        // },
                                        {
                                            name: "lang",
                                            title: TR.value.language,
                                            field_type: 'dropdown',
                                            dropdown_items: countries,
                                            dropdown_item_selected: countries.length ? countries[0].value : 0,
                                            onChange: (e) => {
                                                selected_lang_item.value = countries.filter(l => l.value == e.value)[0].currencySymbol
                                            },
                                        },
                                        {
                                            name: "copy_from",
                                            title: TR.value.json_lang_file_copy,
                                            field_type: 'dropdown',
                                            dropdown_items: G.lang_list,
                                            dropdown_item_selected: G.lang_list[0].value,
                                        },
                                        {
                                            name: "currency_symbol",
                                            title: TR.value.currency,
                                            value: () => {
                                                return selected_lang_item.value || (countries.length ? countries[0].currencySymbol : '');
                                            },
                                            field_type: "text",
                                        },
                                        {
                                            name: "currency_rate",
                                            title: TR.value.currency_rate,
                                            value: () => 1.0,
                                            field_type: 'numeric',
                                            min: 1,
                                            max: 1000000.00,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    onModalClose: (e) => {
                                        G.closeModal(e);
                                    },
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let cn = countries.filter(a => a.value == e.lang)[0];

                                                        if(e && e.lang){
                                                            // let formData = new FormData();
                                                            // if( e.image != data.image && typeof e.image === 'object' ){
                                                            //     formData.append("upload_image", e.image);
                                                            // }
                                                            let lang_data = {
                                                                // "link": e.link ? e.link.replace("\n|\r", "") : '',
                                                                "shortname": cn.value,
                                                                "fullname": cn.label,
                                                                "flag": cn.flag,
                                                                "currency_code": cn.currencyCode,
                                                                "currency_symbol": e.currency_symbol,
                                                                "currency_rate": e.currency_rate,
                                                                "copy_from": G.lang_list.filter(a => a.value == e.copy_from)[0].label,
                                                                "status": e.status ? 1 : 0,
                                                            };

                                                            await ajax({
                                                                url: store.getLangs(),
                                                                method: 'post',
                                                                content_type: 'application/json',
                                                                data: lang_data,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.push(res);
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                if( data.shortname != 'az' ){
                                    G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                        await ajax({
                                            url: store.getLangsUpdate(data.id),
                                            method: 'delete',
                                            success: (e) => {
                                                let res = e.data || null;
                                                if ( e.status == 200 && res){
                                                    tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                    G.alert.success(res.detail);
                                                }
                                                else{
                                                    G.alert.error(res.detail);
                                                }
                                            },
                                        });
                                    }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                                }
                                else{
                                    G.alert.warning(TR.value.msg_main_language_remove_failed);
                                }
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: data.fullname,
                                    modal_width: 30,
                                    dynamic_height: true,
                                    dismiss: false,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns: [
                                        // {
                                        //     name: "preview_image",
                                        //     title: TR.value.preview,
                                        //     // value: (e) => e.image,
                                        //     value: "image",
                                        //     field_type: "label",
                                        // },
                                        // {
                                        //     name: "image",
                                        //     title: TR.value.image,
                                        //     value: (e) => e.image,
                                        //     field_type: "image",
                                        //     fileSelectMode: 'basic',
                                        //     fileMaxSize: G.uploadedFileSize,
                                        //     fileLimit: 1,
                                        //     fileMultiple: false,
                                        // },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "lang",
                                            title: TR.value.language,
                                            field_type: 'dropdown',
                                            dropdown_items: countries,
                                            dropdown_item_selected: data.shortname,
                                            onChange: (e) => {
                                                selected_lang_item.value = countries.filter(l => l.value == e.value)[0].currencySymbol
                                            },
                                        },
                                        {
                                            name: "currency_symbol",
                                            title: TR.value.currency,
                                            value: () => {
                                                return selected_lang_item.value != "" ? selected_lang_item.value : data.currency_symbol;
                                            },
                                            field_type: "text",
                                        },
                                        {
                                            name: "currency_rate",
                                            title: TR.value.currency_rate,
                                            value: "currency_rate",
                                            field_type: 'numeric',
                                            min: 1,
                                            max: 1000000.00,
                                        },
                                        // {
                                        //     name: "shortname",
                                        //     value: "shortname",
                                        //     title: TR.value.shortname,
                                        //     field_type: 'text',
                                        // },
                                        // {
                                        //     name: "fullname",
                                        //     value: "fullname",
                                        //     title: TR.value.name,
                                        //     field_type: 'text',
                                        // },
                                        // {
                                        //     name: "content",
                                        //     value: (e) => e.translate[0].content,
                                        //     title: TR.value.text,
                                        //     field_type: 'textarea',
                                        // },
                                        // {
                                        //     name: "rank",
                                        //     value: "rank",
                                        //     title: TR.value.rank,
                                        //     field_type: 'numeric',
                                        // },
                                        {
                                            name: "create_date",
                                            value: (e) => moment.utc(e.create_date).tz(G.systemData?.timezone?.value).format(G.datetime_format['datetime']),
                                            title: TR.value.date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let cn = countries.filter(a => a.value == e.lang)[0];


                                                        if(e && e.lang){
                                                            // let formData = new FormData();
                                                            // if( e.image != data.image && typeof e.image === 'object' ){
                                                            //     formData.append("upload_image", e.image);
                                                            // }
                                                            let lang_data = {
                                                                // "link": e.link ? e.link.replace("\n|\r", "") : '',
                                                                "shortname": cn.value,
                                                                "fullname": cn.label,
                                                                "flag": cn.flag,
                                                                "currency_code": cn.currencyCode,
                                                                "currency_symbol": e.currency_symbol,
                                                                "currency_rate": e.currency_rate,
                                                                "status": e.status ? 1 : 0,
                                                            };

                                                            // if( e.image != data.image && typeof e.image !== 'object' )
                                                            // lang_data.image = e.image;

                                                            // formData.append("data", JSON.stringify(lang_data));

                                                            await ajax({
                                                                url: store.getLangsUpdate(data.id),
                                                                method: 'patch',
                                                                content_type: 'application/json',
                                                                data: lang_data,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.forEach(
                                                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        );
                                                                        for (let a in res) {
                                                                            data[a] = res[a];
                                                                        }
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_title});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            // label: '',
                            // name: 'update_data',
                            title: TR.value.update,
                            // value: (e) => e.status == 0 ? false : true,
                            class: 'fas fa-edit',
                            // element: 'button',
                            // eventName: 'change',
                            eventCallback: async (data) => {
                                selected_lang.value = data;
                                active.value = '1';
                                getAllKeyValues(data.shortname);
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: `${TR.value.status} ${TR.value.update}`,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getLangsActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime']));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getDoyouknowActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime']));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },

                        // {
                        //     name: "image",
                        //     value: (e) => e.type == 'video' ? '<i class="fas fa-video text-primary"></i>' : ( e.type == 'youtube' ? '<i class="fab fa-youtube text-danger"></i>' :
                        //                         `<img src="${
                        //                                 e.image && typeof e.image !== 'object' && !e.image.match(/youtu/gi)
                        //                                     ? e.image
                        //                                     : "/assets/img/noimg.png"
                        //                             }"
                        //                             alt="${e.image}"
                        //                             class="border img-circle-cover"
                        //                         />`
                        //                     ),
                        //     title: TR.value.image,
                        //     exportable: false,
                        //     sortable: false,
                        //     class: 'text-center',
                        //     filter: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "shortname",
                            value: "shortname",
                            title: TR.value.shortname,
                            class: 'text-center',
                        },
                        {
                            name: "fullname",
                            value: "fullname",
                            title: TR.value.name,
                            class: 'text-center',
                            // filter: false
                        },
                        {
                            name: "currency_rate",
                            value: (e) => e.currency_rate + ' ' + e.currency_symbol,
                            title: TR.value.currency_rate,
                            class: 'text-center',
                            // filter: false
                        },
                        // {
                        //     name: "link",
                        //     value: (e) => e.link !== '' ? '<i class="fas fa-check text-success" />' : '<i class="fas fa-square border text-white" />',
                        //     title: TR.value.link,
                        //     class: 'text-center',
                        //     sortable: false,
                        //     // filter: false
                        // },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            const focusInput = () => {
                if (searchField.value) {
                    searchField.value.inputFieldRef.focus();
                }
            };

            const getLangList = async () => {
                await ajax({
                    url: store.getLangs(),
                    data: {},
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            tableData.value = res;
                            tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime'])));
                        }
                    }
                });
            };

            const getAllKeyValues = async () => {
                // let lng = lang !== undefined ? lang : 'az';
                await ajax({
                    url: store.getSettingsLang(selected_lang.value.shortname),
                    data: {},
                    success: (e) => {
                        language.value = e.data;

                        // if (e && e.data) store.setTranslations(e.data);
                        // TR.value = store.getTranslation();
                    }
                });
            };

            onMounted(async () => {
                await getLangList();
                // await getAllKeyValues();
                focusInput();
                selected_lang_item.value = "";
            });

            const addLanguageKeyValue = (key, val) => {
                if( key !== undefined && key != '' && val !== undefined && val != '' ){
                    if( language.value[key] === undefined ){
                        // console.log(key, val);
                        updateKeyValue(key, val, 'add');
                    }
                    else{
                        G.alert.warning(TR.value.already_exists);
                    }
                }
            };

            const updateLanguageKeyValue = (key, val) => {
                updateKeyValue(key, val, 'update');
            };

            const updateKeyValue = async (key, val, method) => {
                await ajax({
                    url: store.getSettingsLangUpdate(selected_lang.value.shortname),
                    method: method == 'add' ? 'post' : 'patch',
                    content_type: 'application/json; charset=UTF-8',
                    data: {
                        key_index: key,
                        key_value: val.replace('\n', '<br />')
                    },
                    success: (e) => {
                        new_lang.value = {
                            "key": '',
                            "balue": '',
                        };
                        G.alert.success({toast: true, msg: e.data.detail});
                        getAllKeyValues();
                    }
                });
            }

            const removeByKey = (key) => {
                G.alert.confirm({
                    title: TR.value.warning,
                    msg: TR.value.msg_remove_question,
                    yesTitle: TR.value.yes,
                    yes: async () => {
                        ajax({
                            url: store.getSettingsLangRemove(selected_lang.value.shortname),
                            method: 'delete',
                            content_type: 'application/json; charset=UTF-8',
                            data: {
                                key_index: key
                            },
                            success: (e) => {
                                G.alert.success(e.data.detail);
                                getAllKeyValues();
                            }
                        });
                    },
                    noTitle: TR.value.no, no: () => {}
                });
            };

            return {
                G,
                TR,
                tabviewLang,
                tableData,
                tableOptions,
                language,
                searchText,
                filtered,
                addLanguageKeyValue,
                updateLanguageKeyValue,
                removeByKey,
                searchField,
                new_lang,
                selected_lang,
                active,
            };
        },
    };
</script>